// extracted by mini-css-extract-plugin
export var card = "cards-module--card--3IPx_";
export var type = "cards-module--type--3VjpS";
export var title = "cards-module--title--4WCoL";
export var body = "cards-module--body--1lYRF";
export var list = "cards-module--list--qCgrh";
export var button = "cards-module--button--3IyIw";
export var green = "cards-module--green--3ikUj";
export var blue = "cards-module--blue--9N2zX";
export var purple = "cards-module--purple--HbdOY";